import { render } from "./IssueArtical.vue?vue&type=template&id=15a09069&scoped=true"
import script from "./IssueArtical.vue?vue&type=script&lang=js"
export * from "./IssueArtical.vue?vue&type=script&lang=js"

import "./IssueArtical.vue?vue&type=style&index=0&id=15a09069&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15a09069"

export default script